import { DesktopSettings } from './desktop.component'
import { useSettings } from 'src/hooks'

export const AppSettings = () => {
  const { data: settings, isFetching, isLoading } = useSettings()

  return (
    <DesktopSettings
      settings={settings || null}
      isSettingsFetching={isFetching}
      isSettingsLoading={isLoading}
    />
  )
}
